module.exports = "pegasus/assets/blocks/column-11-theme4.png";